"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_set_1 = require("./extension-set");
const core_1 = require("./extension/core");
const lexer_1 = require("./lexer");
const parser_1 = require("./parser");
const source_1 = require("./source");
const loader_1 = require("./error/loader");
const syntax_1 = require("./error/syntax");
const escaper_1 = require("./extension/escaper");
const template_1 = require("./template");
const error_1 = require("./error");
const template_wrapper_1 = require("./template-wrapper");
const array_1 = require("./loader/array");
const chain_1 = require("./loader/chain");
const optimizer_1 = require("./extension/optimizer");
const compiler_1 = require("./compiler");
const null_1 = require("./cache/null");
const runtime_1 = require("./error/runtime");
const merge_1 = require("./helper/merge");
const events_1 = require("events");
const output_buffering_1 = require("./output-buffering");
const clone_1 = require("./helper/clone");
const compare_1 = require("./helper/compare");
const count_1 = require("./helper/count");
const each_1 = require("./helper/each");
const is_countable_1 = require("./helper/is-countable");
const is_map_1 = require("./helper/is-map");
const is_plain_object_1 = require("./helper/is-plain-object");
const iterator_to_map_1 = require("./helper/iterator-to-map");
const regex_parser_1 = require("./helper/regex-parser");
const markup_1 = require("./markup");
const range_1 = require("./helper/range");
const profile_1 = require("./profiler/profile");
const security_error_1 = require("./sandbox/security-error");
const security_not_allowed_filter_error_1 = require("./sandbox/security-not-allowed-filter-error");
const security_not_allowed_function_error_1 = require("./sandbox/security-not-allowed-function-error");
const security_not_allowed_tag_error_1 = require("./sandbox/security-not-allowed-tag-error");
const context_1 = require("./context");
const path = require('path');
const sha256 = require('crypto-js/sha256');
const hex = require('crypto-js/enc-hex');
exports.VERSION = '2.3.7';
/**
 * Stores the Twing configuration.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingEnvironment extends events_1.EventEmitter {
    /**
     * Constructor.
     *
     * @param {TwingLoaderInterface} loader
     * @param {TwingEnvironmentOptions} options
     */
    constructor(loader, options = null) {
        super();
        this.loader = null;
        this.globals = new Map();
        this.loadedTemplates = new Map();
        this.templateClassPrefix = '__TwingTemplate_';
        this.extensionSet = null;
        this.runtimeLoaders = [];
        this.runtimes = new Map();
        this.setLoader(loader);
        options = Object.assign({}, {
            debug: false,
            charset: 'UTF-8',
            base_template_class: 'TwingTemplate',
            strict_variables: false,
            autoescape: 'html',
            cache: false,
            auto_reload: null,
            optimizations: -1,
            source_map: false
        }, options);
        this.debug = options.debug;
        this.setCharset(options.charset);
        this.baseTemplateClass = options.base_template_class;
        this.autoReload = options.auto_reload === null ? this.debug : options.auto_reload;
        this.strictVariables = options.strict_variables;
        this.setCache(options.cache);
        this.extensionSet = new extension_set_1.TwingExtensionSet();
        this.sourceMap = options.source_map;
        this.autoescape = options.autoescape;
        this.addExtension(new core_1.TwingExtensionCore(), 'TwingExtensionCore');
        this.addExtension(new escaper_1.TwingExtensionEscaper(options.autoescape), 'TwingExtensionEscaper');
        this.addExtension(new optimizer_1.TwingExtensionOptimizer(options.optimizations), 'TwingExtensionOptimizer');
        this.setTemplateRuntime({
            clone: clone_1.clone,
            compare: compare_1.compare,
            count: count_1.count,
            each: each_1.each,
            isCountable: is_countable_1.isCountable,
            isMap: is_map_1.isMap,
            isPlainObject: is_plain_object_1.isPlainObject,
            iteratorToMap: iterator_to_map_1.iteratorToMap,
            merge: merge_1.merge,
            regexParser: regex_parser_1.regexParser,
            TwingErrorLoader: loader_1.TwingErrorLoader,
            TwingErrorRuntime: runtime_1.TwingErrorRuntime,
            twingArrayMerge: core_1.twingArrayMerge,
            twingConstant: core_1.twingConstant,
            twingEnsureTraversable: core_1.twingEnsureTraversable,
            twingGetAttribute: core_1.twingGetAttribute,
            twingInFilter: core_1.twingInFilter,
            TwingMarkup: markup_1.TwingMarkup,
            echo: output_buffering_1.echo,
            flush: output_buffering_1.flush,
            obEndClean: output_buffering_1.obEndClean,
            obGetClean: output_buffering_1.obGetClean,
            obGetContents: output_buffering_1.obGetContents,
            obStart: output_buffering_1.obStart,
            range: range_1.range,
            TwingSandboxSecurityError: security_error_1.TwingSandboxSecurityError,
            TwingSandboxSecurityNotAllowedFilterError: security_not_allowed_filter_error_1.TwingSandboxSecurityNotAllowedFilterError,
            TwingSandboxSecurityNotAllowedFunctionError: security_not_allowed_function_error_1.TwingSandboxSecurityNotAllowedFunctionError,
            TwingSandboxSecurityNotAllowedTagError: security_not_allowed_tag_error_1.TwingSandboxSecurityNotAllowedTagError,
            TwingSource: source_1.TwingSource,
            TwingTemplate: template_1.TwingTemplate,
            TwingProfilerProfile: profile_1.TwingProfilerProfile,
            TwingContext: context_1.TwingContext
        });
    }
    /**
     * Gets the base template class for compiled templates.
     *
     * @returns {string} The base template class name
     */
    getBaseTemplateClass() {
        return this.baseTemplateClass;
    }
    /**
     * Sets the base template class for compiled templates.
     *
     * @param {string} templateClass The base template class name
     */
    setBaseTemplateClass(templateClass) {
        this.baseTemplateClass = templateClass;
        this.updateOptionsHash();
    }
    /**
     * Enables debugging mode.
     */
    enableDebug() {
        this.debug = true;
        this.updateOptionsHash();
    }
    /**
     * Disables debugging mode.
     */
    disableDebug() {
        this.debug = false;
        this.updateOptionsHash();
    }
    /**
     * Checks if debug mode is enabled.
     *
     * @returns {boolean} true if debug mode is enabled, false otherwise
     */
    isDebug() {
        return this.debug;
    }
    /**
     * Enables the auto_reload option.
     */
    enableAutoReload() {
        this.autoReload = true;
    }
    /**
     * Disables the auto_reload option.
     */
    disableAutoReload() {
        this.autoReload = false;
    }
    /**
     * Checks if the auto_reload option is enabled.
     *
     * @returns {boolean} true if auto_reload is enabled, false otherwise
     */
    isAutoReload() {
        return this.autoReload;
    }
    /**
     * Enables the strict_variables option.
     */
    enableStrictVariables() {
        this.strictVariables = true;
        this.updateOptionsHash();
    }
    /**
     * Disables the strict_variables option.
     */
    disableStrictVariables() {
        this.strictVariables = false;
        this.updateOptionsHash();
    }
    /**
     * Checks if the strict_variables option is enabled.
     *
     * @returns {boolean} true if strict_variables is enabled, false otherwise
     */
    isStrictVariables() {
        return this.strictVariables;
    }
    /**
     * Gets the active cache implementation.
     *
     * @param {boolean} original Whether to return the original cache option or the real cache instance
     *
     * @returns {TwingCacheInterface|string|false} A TwingCacheInterface implementation,
     *                                                an absolute path to the compiled templates,
     *                                                or false to disable cache
     */
    getCache(original = true) {
        return original ? this.originalCache : this.cache;
    }
    /**
     * Sets the active cache implementation.
     *
     * @param {TwingCacheInterface|string|false} cache A TwingCacheInterface implementation, a string or false to disable cache
     */
    setCache(cache) {
        if (typeof cache === 'string') {
            this.originalCache = cache;
            this.cache = this.cacheFromString(cache);
        }
        else if (cache === false) {
            this.originalCache = cache;
            this.cache = new null_1.TwingCacheNull();
        }
        else if (cache.TwingCacheInterfaceImpl) {
            this.originalCache = this.cache = cache;
        }
        else {
            throw new Error(`Cache can only be a string, false or a TwingCacheInterface implementation.`);
        }
    }
    setTemplateRuntime(runtime) {
        this.templateRuntime = runtime;
    }
    getTemplateRuntime() {
        return this.templateRuntime;
    }
    /**
     * Gets the template class associated with the given string.
     *
     * The generated template class is based on the following parameters:
     *
     *  * The cache key for the given template;
     *  * The currently enabled extensions;
     *  * Twing version;
     *  * Options with what environment was created.
     *
     * @param {string} name The name for which to calculate the template class name
     * @param {number|null} index The index if it is an embedded template
     * @param {TwingSource} from The source that initiated the template loading
     *
     * @return string The template class name
     */
    getTemplateClass(name, index = null, from = null) {
        let key = this.getLoader().getCacheKey(name, from) + this.optionsHash;
        return this.templateClassPrefix + hex.stringify(sha256(key)) + (index === null ? '' : '_' + index);
    }
    /**
     * Checks if the source_map option is enabled.
     *
     * @returns {boolean} true if source_map is enabled, false otherwise
     */
    isSourceMap() {
        return this.sourceMap;
    }
    /**
     * Renders a template.
     *
     * @param {string} name The template name
     * @param {{}} context An array of parameters to pass to the template
     * @returns {Promise<string>}
     */
    render(name, context = {}) {
        return this.loadTemplate(name).render(context);
    }
    /**
     * Displays a template.
     *
     * @param {string} name The template name
     * @param {{}} context An array of parameters to pass to the template
     *
     * @throws TwingErrorLoader  When the template cannot be found
     * @throws TwingErrorSyntax  When an error occurred during compilation
     * @throws TwingErrorRuntime When an error occurred during rendering
     */
    display(name, context = {}) {
        this.loadTemplate(name).display(context);
    }
    /**
     * Loads a template.
     *
     * @param {string | TwingTemplateWrapper | TwingTemplate} name The template name
     *
     * @throws {TwingErrorLoader}  When the template cannot be found
     * @throws {TwingErrorRuntime} When a previously generated cache is corrupted
     * @throws {TwingErrorSyntax}  When an error occurred during compilation
     *
     * @returns {TwingTemplateWrapper}
     */
    load(name) {
        if (name instanceof template_wrapper_1.TwingTemplateWrapper) {
            return name;
        }
        if (name instanceof template_1.TwingTemplate) {
            return new template_wrapper_1.TwingTemplateWrapper(this, name);
        }
        return new template_wrapper_1.TwingTemplateWrapper(this, this.loadTemplate(name));
    }
    /**
     * Loads a template internal representation.
     *
     * This method is for internal use only and should never be called
     * directly.
     *
     * @param {string} name  The template name
     * @param {number} index The index if it is an embedded template
     * @param {TwingSource} from The source that initiated the template loading
     *
     * @returns {TwingTemplate} A template instance representing the given template name
     *
     * @throws {TwingErrorLoader}  When the template cannot be found
     * @throws {TwingErrorRuntime} When a previously generated cache is corrupted
     * @throws {TwingErrorSyntax}  When an error occurred during compilation
     *
     * @internal
     */
    loadTemplate(name, index = null, from = null) {
        this.emit('template', name, from);
        let cls = this.getTemplateClass(name, null, from);
        let mainCls = cls;
        if (index !== null) {
            cls = `${cls}_${index}`;
        }
        if (this.loadedTemplates.has(cls)) {
            return this.loadedTemplates.get(cls);
        }
        let cache = this.cache;
        let key = cache.generateKey(name, mainCls);
        let templates = {};
        let runtime = this.getTemplateRuntime();
        if (!this.isAutoReload() || this.isTemplateFresh(name, cache.getTimestamp(key), from)) {
            templates = cache.load(key)(runtime);
        }
        if (!templates[cls]) {
            let source = this.getLoader().getSourceContext(name, from);
            let content = this.compileSource(source);
            cache.write(key, content);
            templates = cache.load(key)(runtime);
            if (!templates[cls]) {
                templates = new Function(`let module = {
    exports: undefined
};

${content}

return module.exports;

`)()(runtime);
                if (!templates[cls]) {
                    throw new runtime_1.TwingErrorRuntime(`Failed to load Twig template "${name}", index "${index}": cache is corrupted.`, -1, source);
                }
            }
        }
        // to be removed in 3.0
        this.extensionSet.initRuntime(this);
        let mainTemplate;
        for (let key in templates) {
            let Tpl = templates[key];
            let template = new Tpl(this);
            if (key === mainCls) {
                key = cls;
                mainTemplate = template;
            }
            this.loadedTemplates.set(key, template);
        }
        return mainTemplate;
    }
    /**
     * Creates a template from source.
     *
     * This method should not be used as a generic way to load templates.
     *
     * @param {string} template The template name
     * @param {string} name An optional name for the template to be used in error messages
     *
     * @returns {TwingTemplate} A template instance representing the given template name
     *
     * @throws TwingErrorLoader When the template cannot be found
     * @throws TwingErrorSyntax When an error occurred during compilation
     */
    createTemplate(template, name = null) {
        let result;
        let hash = hex.stringify(sha256(template));
        if (name !== null) {
            name = `${name} (string template ${hash})`;
        }
        else {
            name = `__string_template__${hash}`;
        }
        let current = this.getLoader();
        let loader = new chain_1.TwingLoaderChain([
            current,
            new array_1.TwingLoaderArray(new Map([[name, template]])),
        ]);
        this.setLoader(loader);
        result = this.loadTemplate(name);
        return result;
    }
    /**
     * Returns true if the template is still fresh.
     *
     * @param {string} name The template name
     * @param {number} time The last modification time of the cached template
     * @param {TwingSource} from The source that initiated the template loading
     *
     * @returns {boolean} true if the template is fresh, false otherwise
     */
    isTemplateFresh(name, time, from) {
        return this.getLoader().isFresh(name, time, from);
    }
    /**
     * Tries to load a template consecutively from an array.
     *
     * Similar to loadTemplate() but it also accepts instances of TwingTemplate and
     * TwingTemplateWrapper, and an array of templates where each is tried to be loaded.
     *
     * @param {string|TwingTemplate|TwingTemplateWrapper|Array<string|TwingTemplate>} names A template or an array of templates to try consecutively
     *
     * @returns {TwingTemplate|TwingTemplateWrapper}
     *
     * @throws {TwingErrorLoader} When none of the templates can be found
     * @throws {TwingErrorSyntax} When an error occurred during compilation
     */
    resolveTemplate(names, source = null) {
        let self = this;
        let namesArray;
        if (!Array.isArray(names)) {
            namesArray = [names];
        }
        else {
            namesArray = names;
        }
        let error = null;
        for (let name of namesArray) {
            if (name instanceof template_1.TwingTemplate) {
                return name;
            }
            if (name instanceof template_wrapper_1.TwingTemplateWrapper) {
                return name;
            }
            try {
                return self.loadTemplate(name, null, source);
            }
            catch (e) {
                if (e instanceof loader_1.TwingErrorLoader) {
                    error = e;
                }
                else {
                    throw e;
                }
            }
        }
        if (namesArray.length === 1) {
            throw error;
        }
        throw new loader_1.TwingErrorLoader(`Unable to find one of the following templates: "${namesArray.join(', ')}".`);
    }
    setLexer(lexer) {
        this.lexer = lexer;
    }
    /**
     * Tokenizes a source code.
     *
     * @param {TwingSource} source The source to tokenize
     * @returns {TwingTokenStream}
     *
     * @throws {TwingErrorSyntax} When the code is syntactically wrong
     */
    tokenize(source) {
        if (!this.lexer) {
            this.lexer = new lexer_1.TwingLexer(this);
        }
        return this.lexer.tokenize(source);
    }
    setParser(parser) {
        this.parser = parser;
    }
    /**
     * Converts a token stream to a template.
     *
     * @param {TwingTokenStream} stream
     * @returns {TwingNodeModule}
     *
     * @throws {TwingErrorSyntax} When the token stream is syntactically or semantically wrong
     */
    parse(stream) {
        if (!this.parser) {
            this.parser = new parser_1.TwingParser(this);
        }
        return this.parser.parse(stream);
    }
    /**
     * Compiles a node and returns its compiled templates.
     *
     * @returns { Map<number, TwingTemplate> } The compiled templates
     */
    compile(node) {
        let compiler = new compiler_1.TwingCompiler(this);
        return compiler.compile(node).getSource();
    }
    /**
     *
     * @param {TwingSource} source
     * @returns {Map<number, TwingTemplate> }
     */
    compileSource(source) {
        try {
            return this.compile(this.parse(this.tokenize(source)));
        }
        catch (e) {
            if (e instanceof error_1.TwingError) {
                throw e;
            }
            else {
                throw new syntax_1.TwingErrorSyntax(`An exception has been thrown during the compilation of a template ("${e.message}").`, -1, source);
            }
        }
    }
    setLoader(loader) {
        this.loader = loader;
    }
    /**
     * Gets the Loader instance.
     *
     * @return TwingLoaderInterface
     */
    getLoader() {
        return this.loader;
    }
    /**
     * Sets the default template charset.
     *
     * @param {string} charset The default charset
     */
    setCharset(charset) {
        this.charset = charset;
    }
    /**
     * Gets the default template charset.
     *
     * @return {string} The default charset
     */
    getCharset() {
        return this.charset;
    }
    /**
     * Returns true if the given extension is registered.
     *
     * @param {string} name
     * @returns {boolean}
     */
    hasExtension(name) {
        return this.extensionSet.hasExtension(name);
    }
    /**
     * Adds a runtime loader.
     */
    addRuntimeLoader(loader) {
        this.runtimeLoaders.push(loader);
    }
    /**
     * Gets an extension by name.
     *
     * @param {string} name
     * @returns {TwingExtensionInterface}
     */
    getExtension(name) {
        return this.extensionSet.getExtension(name);
    }
    /**
     * Returns the runtime implementation of a Twig element (filter/function/test).
     *
     * @param {string} class_ A runtime class name
     *
     * @returns {{}} The runtime implementation
     *
     * @throws TwingErrorRuntime When the runtime cannot be found
     */
    getRuntime(class_) {
        if (this.runtimes.has(class_)) {
            return this.runtimes.get(class_);
        }
        for (let loader of this.runtimeLoaders) {
            let runtime = loader.load(class_);
            if (runtime !== null) {
                this.runtimes.set(class_, runtime);
                return runtime;
            }
        }
        throw new runtime_1.TwingErrorRuntime(`Unable to load the "${class_}" runtime.`);
    }
    /**
     *
     * @param {TwingExtensionInterface} extension
     * @param {string} name
     */
    addExtension(extension, name = null) {
        this.extensionSet.addExtension(extension, name);
        this.updateOptionsHash();
    }
    /**
     * Registers an array of extensions.
     *
     * @param {Array<TwingExtensionInterface>} extensions An array of extensions
     */
    setExtensions(extensions) {
        this.extensionSet.setExtensions(extensions);
        this.updateOptionsHash();
    }
    /**
     * Returns all registered extensions.
     *
     * @returns Map<string, TwingExtensionInterface> A hash of extensions (keys are for internal usage only and should not be relied on)
     */
    getExtensions() {
        return this.extensionSet.getExtensions();
    }
    addTokenParser(parser) {
        this.extensionSet.addTokenParser(parser);
    }
    /**
     * Gets the registered Token Parsers.
     *
     * @returns {Array<TwingTokenParserInterface>}
     *
     * @internal
     */
    getTokenParsers() {
        return this.extensionSet.getTokenParsers();
    }
    /**
     * Gets registered tags.
     *
     * @return Map<string, TwingTokenParserInterface>
     *
     * @internal
     */
    getTags() {
        let tags = new Map();
        this.getTokenParsers().forEach(function (parser) {
            tags.set(parser.getTag(), parser);
        });
        return tags;
    }
    addNodeVisitor(visitor) {
        this.extensionSet.addNodeVisitor(visitor);
    }
    /**
     * Gets the registered Node Visitors.
     *
     * @returns {Array<TwingNodeVisitorInterface>}
     *
     * @internal
     */
    getNodeVisitors() {
        return this.extensionSet.getNodeVisitors();
    }
    addFilter(filter) {
        this.extensionSet.addFilter(filter);
    }
    /**
     * Get a filter by name.
     *
     * Subclasses may override this method and load filters differently;
     * so no list of filters is available.
     *
     * @param string name The filter name
     *
     * @return Twig_Filter|false A Twig_Filter instance or null if the filter does not exist
     *
     * @internal
     */
    getFilter(name) {
        return this.extensionSet.getFilter(name);
    }
    registerUndefinedFilterCallback(callable) {
        this.extensionSet.registerUndefinedFilterCallback(callable);
    }
    /**
     * Gets the registered Filters.
     *
     * Be warned that this method cannot return filters defined with registerUndefinedFilterCallback.
     *
     * @return Twig_Filter[]
     *
     * @see registerUndefinedFilterCallback
     *
     * @internal
     */
    getFilters() {
        return this.extensionSet.getFilters();
    }
    /**
     * Registers a Test.
     *
     * @param {TwingTest} test
     */
    addTest(test) {
        this.extensionSet.addTest(test);
    }
    /**
     * Gets the registered Tests.
     *
     * @returns {Map<string, TwingTest>}
     */
    getTests() {
        return this.extensionSet.getTests();
    }
    /**
     * Gets a test by name.
     *
     * @param {string} name The test name
     * @returns {TwingTest} A TwingTest instance or null if the test does not exist
     */
    getTest(name) {
        return this.extensionSet.getTest(name);
    }
    addFunction(aFunction) {
        this.extensionSet.addFunction(aFunction);
    }
    /**
     * Get a function by name.
     *
     * Subclasses may override this method and load functions differently;
     * so no list of functions is available.
     *
     * @param {string} name function name
     *
     * @returns {TwingFunction} A TwingFunction instance or null if the function does not exist
     *
     * @internal
     */
    getFunction(name) {
        return this.extensionSet.getFunction(name);
    }
    registerUndefinedFunctionCallback(callable) {
        this.extensionSet.registerUndefinedFunctionCallback(callable);
    }
    /**
     * Gets registered functions.
     *
     * Be warned that this method cannot return functions defined with registerUndefinedFunctionCallback.
     *
     * @return Twig_Function[]
     *
     * @see registerUndefinedFunctionCallback
     *
     * @internal
     */
    getFunctions() {
        return this.extensionSet.getFunctions();
    }
    /**
     * Registers a Global.
     *
     * New globals can be added before compiling or rendering a template;
     * but after, you can only update existing globals.
     *
     * @param {string} name The global name
     * @param {*} value The global value
     */
    addGlobal(name, value) {
        if (this.extensionSet.isInitialized() && !this.getGlobals().has(name)) {
            throw new Error(`Unable to add global "${name}" as the runtime or the extensions have already been initialized.`);
        }
        if (this.resolvedGlobals) {
            this.resolvedGlobals.set(name, value);
        }
        else {
            this.globals.set(name, value);
        }
    }
    /**
     * Gets the registered Globals.
     *
     * @return array An array of globals
     *
     * @internal
     */
    getGlobals() {
        if (this.extensionSet.isInitialized()) {
            if (!this.resolvedGlobals) {
                this.resolvedGlobals = merge_1.merge(this.extensionSet.getGlobals(), this.globals);
            }
            return this.resolvedGlobals;
        }
        return merge_1.merge(this.extensionSet.getGlobals(), this.globals);
    }
    /**
     * Merges a context with the defined globals.
     *
     * @param {Map<*, *>} context
     * @returns {Map<*, *>}
     */
    mergeGlobals(context) {
        // we don't use Twing merge as the context being generally
        // bigger than globals, this code is faster.
        for (let [key, value] of this.getGlobals()) {
            if (!context.has(key)) {
                context.set(key, value);
            }
        }
        return context;
    }
    /**
     * Gets the registered unary Operators.
     *
     * @return Map<string, TwingOperator> A map of unary operators
     *
     * @internal
     */
    getUnaryOperators() {
        return this.extensionSet.getUnaryOperators();
    }
    /**
     * Gets the registered binary Operators.
     *
     * @return Map<string, TwingOperator> An array of binary operators
     *
     * @internal
     */
    getBinaryOperators() {
        return this.extensionSet.getBinaryOperators();
    }
    updateOptionsHash() {
        this.optionsHash = [
            this.extensionSet.getSignature(),
            exports.VERSION,
            this.debug,
            this.baseTemplateClass,
            this.strictVariables,
            this.sourceMap,
            typeof this.autoescape === 'function' ? 'function' : this.autoescape
        ].join(':');
    }
    /**
     * @param {number} line 0-based
     * @param {number} column 1-based
     * @param {string} name
     * @param {TwingSource} source
     * @param {TwingSourceMapNodeConstructor} ctor
     */
    enterSourceMapBlock(line, column, name, source, ctor) {
        output_buffering_1.TwingOutputBuffering.obStart();
        let sourcePath = path.relative('.', source.getPath());
        if (typeof this.sourceMap === 'string') {
            sourcePath = path.join(this.sourceMap, sourcePath);
        }
        source = new source_1.TwingSource(source.getCode(), source.getName(), sourcePath);
        let node = new ctor(line, column - 1, source, name);
        if (this.sourceMapNode) {
            this.sourceMapNode.addChild(node);
        }
        this.sourceMapNode = node;
    }
    leaveSourceMapBlock() {
        this.sourceMapNode.content = output_buffering_1.TwingOutputBuffering.obGetFlush();
        let parent = this.sourceMapNode.parent;
        if (parent) {
            this.sourceMapNode = parent;
        }
    }
    getSourceMap() {
        let sourceMap = null;
        if (this.isSourceMap() && this.sourceMapNode) {
            let sourceNode = this.sourceMapNode.toSourceNode();
            let codeAndMap = sourceNode.toStringWithSourceMap();
            sourceMap = codeAndMap.map.toString();
        }
        return sourceMap;
    }
}
exports.TwingEnvironment = TwingEnvironment;
